// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1135":"1db2959f","6429":"c2401150","9694":"984ff081","9875":"1db2959f"}[chunkId] + ".chunk.css";
};